<template>
  <div class="some-search">
    <p class="some-search-label" :title="title" v-if="title">{{title}}</p>
    <div class="some-search-content">
      <slot name="letter"></slot>
      <slot name="searchList"></slot>
    </div>
  </div>
</template>
<script>
// import MyLetter from '@/components/base/letterSearch/Letter'
// import MySearchList from '@/components/base/letterSearch/SearchList'

export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    // MyLetter
    // MySearchList
  }
};
</script>
<style lang="stylus" scoped>
.some-search
  display flex
  flex-flow row nowrap
  // border-bottom: 1px solid #e4e4e4;
  padding-bottom: 7px;
  // margin-bottom: 28px;
  align-items: flex-start;
  .some-search-label
    flex: 0 0 120px;
    font-size 12px
    line-height: 30px;
    height 32px
    white-space nowrap
  .some-search-content
    display: flex;
    flex-flow: column;
    align-items: self-start;

</style>



// WEBPACK FOOTER //
// src/components/base/letterSearch/LetterSearch.vue